import { StyleSheet } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'

export const getCreateGroupModalStyles = (theme: Theme) =>
  StyleSheet.create({
    modalContainer: {
      backgroundColor: theme.background.card,
      borderRadius: 24,
      borderWidth: 1,
      borderColor: theme.gray[200],
      paddingHorizontal: 24,
      paddingVertical: 20,
      marginHorizontal: 20,
      maxWidth: 420,
    },
    title: {
      fontSize: 20,
      fontWeight: '700',
      color: theme.gray[800],
      marginBottom: 4,
    },
    subtitle: {
      fontSize: 13,
      color: theme.gray[500],
      marginBottom: 12,
    },
    input: {
      borderRadius: 12,
      paddingHorizontal: 12,
      paddingVertical: 10,
      backgroundColor: theme.gray[200],
      fontSize: 16,
      color: theme.gray[800],
      marginBottom: 4,
    },
    charCount: {
      fontSize: 12,
      color: theme.gray[500],
      marginBottom: 12,
    },
    memberLimitHint: {
      fontSize: 12,
      color: theme.gray[500],
      marginBottom: 14,
    },
    memberLimitPro: {
      color: theme.accent,
      fontWeight: '600',
    },
    checkboxRow: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: 16,
    },
    checkbox: {
      width: 22,
      height: 22,
      borderRadius: 6,
      borderWidth: 2,
      borderColor: theme.gray[300],
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 10,
    },
    checkboxChecked: {
      backgroundColor: theme.primary,
      borderColor: theme.primary,
    },
    checkboxCheckmark: {
      fontSize: 14,
      fontWeight: '700',
      color: theme.onPrimary,
    },
    checkboxLabel: {
      fontSize: 14,
      fontWeight: '500',
      color: theme.gray[700],
      flex: 1,
    },
    footer: {
      flexDirection: 'row',
      justifyContent: 'flex-end',
    },
    cancelButton: {
      paddingHorizontal: 16,
      paddingVertical: 10,
      borderRadius: 999,
      backgroundColor: theme.gray[200],
      marginRight: 8,
    },
    cancelButtonText: {
      fontSize: 14,
      fontWeight: '500',
      color: theme.gray[700],
    },
    createButton: {
      paddingHorizontal: 20,
      paddingVertical: 10,
      borderRadius: 999,
      backgroundColor: theme.primary,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 96,
    },
    createButtonDisabled: {
      backgroundColor: theme.gray[300],
    },
    createButtonText: {
      fontSize: 14,
      fontWeight: '600',
      color: theme.onPrimary,
    },
    createButtonLoader: {
      marginRight: 8,
    },
  })
